import { Collaborator } from '../api/krakenn-api';

export class CollaboratorType {
  static className = 'Collaborator';
  static gqlRootQueryName = 'collaborator';
  static gqlColumns: string[] = [
      '_id',
      'jiraLogin',
      'firstName',
      'lastName',
      'companyName',
      'costPerDay',
      'email',
      'expirationDate',
      'phoneNumber',
      'scheduledReports',
      'trigram',
  ];

  static gqlNodeMapper = (node: any): Collaborator => {
        node.id = node._id;
        delete node._id;
        delete node.__typename;
        return node as Collaborator;
    }

}
